import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "v-live-stats" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { colspan: "3" }
const _hoisted_4 = { class: "badge fail" }
const _hoisted_5 = { class: "badge progress" }
const _hoisted_6 = { class: "badge closed" }
const _hoisted_7 = { class: "badge kpi" }
const _hoisted_8 = { class: "stats" }
const _hoisted_9 = { class: "progress" }
const _hoisted_10 = { class: "live" }
const _hoisted_11 = { class: "hour" }
const _hoisted_12 = { class: "hour__time" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "work" }
const _hoisted_15 = { class: "work__track" }
const _hoisted_16 = { class: "work__info" }
const _hoisted_17 = { class: "percent" }
const _hoisted_18 = { class: "number" }
const _hoisted_19 = { class: "kpi" }
const _hoisted_20 = { class: "kpi__track" }
const _hoisted_21 = { class: "kpi__info" }
const _hoisted_22 = { class: "percent" }
const _hoisted_23 = { class: "number" }
const _hoisted_24 = { class: "violation" }
const _hoisted_25 = { class: "violation__number" }
const _hoisted_26 = { class: "inspection" }
const _hoisted_27 = { class: "inspection__number" }
const _hoisted_28 = { class: "upload" }
const _hoisted_29 = { class: "upload__number" }

import { useLiveStatsStore } from "@/features/live-stats/live-stats.store";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { Hourglass03 } from "utruckin-icons";

const totalBars = 30;


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveStatsView',
  setup(__props) {

const liveStatsStore = useLiveStatsStore();

const now = ref(Date.now());
const workMaxNumber = computed(() => {
  return liveStatsStore.liveStatsData?.current_shift_users
    ? liveStatsStore.liveStatsData?.current_shift_users.length * 100
    : 0;
});

const workPercent = computed(() => {
  return Math.round(
    (shiftData.value?.counts.closed / workMaxNumber.value) * 100
  );
});

const workFilledBars = computed(() => {
  return Math.round((workPercent.value / 100) * totalBars);
});

const workBars = computed(() =>
  Array.from({ length: totalBars }, (_, i) => i < workFilledBars.value)
);

const kpiMaxNumber = computed(() => {
  return liveStatsStore.liveStatsData?.current_shift_users
    ? liveStatsStore.liveStatsData?.current_shift_users.length * 400
    : 0;
});

const kpiPercent = computed(() => {
  return Math.round((shiftData.value?.total_kpi / kpiMaxNumber.value) * 100);
});

const kpiFilledBars = computed(() => {
  return Math.round((kpiPercent.value / 100) * totalBars);
});

const kpiBars = computed(() =>
  Array.from({ length: totalBars }, (_, i) => i < kpiFilledBars.value)
);

let timer: ReturnType<typeof setInterval>;

const data = computed(() => {
  return liveStatsStore.liveStatsData;
});

const shiftData = computed(() => {
  const currentShiftName = liveStatsStore.liveStatsData?.current_shift?.name;
  let result = null;
  if (liveStatsStore.liveStatsData?.work_totals?.by_shift?.length) {
    liveStatsStore.liveStatsData?.work_totals?.by_shift.forEach((item) => {
      if (item.shift_name == currentShiftName) {
        result = item;
      }
    });
  }
  return result;
});

const remainingTime = computed(() => {
  const endTime = liveStatsStore.liveStatsData?.current_shift?.end_time;

  if (!endTime) {
    return "00 : 00 : 00";
  }

  const diff = Math.max(
    0,
    Math.floor((new Date(endTime).getTime() - now.value) / 1000)
  );

  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor((diff % 3600) / 60);
  const seconds = diff % 60;

  return `${String(hours).padStart(2, "0")} : ${String(minutes).padStart(
    2,
    "0"
  )} : ${String(seconds).padStart(2, "0")}`;
});

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
          _createElementVNode("col", { style: {"width":"1%"} }),
          _createElementVNode("col", { style: {"width":"15%"} }),
          _createElementVNode("col", { style: {"width":"7%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"30%"} })
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "No"),
            _createElementVNode("th", null, "Username"),
            _createElementVNode("th", null, "Team"),
            _createElementVNode("th", null, "QA failed"),
            _createElementVNode("th", null, "In progress"),
            _createElementVNode("th", null, "Closed"),
            _createElementVNode("th", null, "KPI"),
            _createElementVNode("th", null, "Statistics")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(data.value?.current_shift?.name), 1),
            _createElementVNode("td", null, _toDisplayString(shiftData.value?.counts.qa_failed), 1),
            _createElementVNode("td", null, _toDisplayString(shiftData.value?.counts.in_progress), 1),
            _createElementVNode("td", null, _toDisplayString(shiftData.value?.counts.closed), 1),
            _createElementVNode("td", null, _toDisplayString(shiftData.value?.total_kpi), 1),
            _cache[0] || (_cache[0] = _createElementVNode("td", null, null, -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.current_shift_users, (userData, userIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: userData.user_id
            }, [
              _createElementVNode("td", null, _toDisplayString(userIndex + 1), 1),
              _createElementVNode("td", null, _toDisplayString(userData.name), 1),
              _createElementVNode("td", null, _toDisplayString(userData.team_name), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(userData.counts.qa_failed), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(userData.counts.in_progress), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(userData.counts.closed), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(userData.total_kpi), 1)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "bar",
                    style: _normalizeStyle({ width: `${(userData.counts.closed * 100) / 100}%` })
                  }, null, 4)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hour__info" }, [
          _createElementVNode("div", { class: "hour__info--text" }, "Live"),
          _createElementVNode("div", { class: "hour__info--icon" })
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(remainingTime.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "work__header" }, [
          _createElementVNode("div", { class: "title" }, "Work")
        ], -1)),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workBars.value, (filled, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["segment", { filled }])
            }, null, 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(workPercent.value) + "%", 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(shiftData.value?.counts.closed) + " / " + _toDisplayString(workMaxNumber.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "kpi__header" }, [
          _createElementVNode("div", { class: "title" }, "KPI")
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiBars.value, (filled, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["segment", { filled }])
            }, null, 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(kpiPercent.value) + "%", 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(shiftData.value?.total_kpi) + " / " + _toDisplayString(kpiMaxNumber.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "violation__title" }, "Violations", -1)),
        _createElementVNode("div", _hoisted_25, _toDisplayString(data.value?.active_alerts?.eld_violations), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "inspection__title" }, "Inspections", -1)),
        _createElementVNode("div", _hoisted_27, _toDisplayString(data.value?.inspections_today?.total), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "upload__title" }, "No inspection files", -1)),
        _createElementVNode("div", _hoisted_29, _toDisplayString(data.value?.inspections_today?.no_output_files), 1)
      ])
    ])
  ]))
}
}

})